var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_20_12",
    "data-name": "Component 20 \\u2013 12",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44842",
    "data-name": "Group 44842",
    transform: "translate(44 44) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5380",
    "data-name": "Rectangle 5380",
    fill: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_30885",
    "data-name": "Path 30885",
    d: "M15.116,4.009a4.793,4.793,0,0,1-2.1-3.136A4.788,4.788,0,0,1,12.937,0H9.5L9.493,13.78a2.889,2.889,0,1,1-2.885-3,2.844,2.844,0,0,1,.853.134V7.4a6.327,6.327,0,1,0,5.476,6.267V6.684a8.178,8.178,0,0,0,4.784,1.538V4.784A4.754,4.754,0,0,1,15.116,4.009Z",
    transform: "translate(31 32) rotate(-180)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.903a05f5f14c82062ee7d62a2185f251.svg";
export { ForwardRef as ReactComponent };